/* @flow */
import {
  format,
  isToday,
  isYesterday,
  isTomorrow,
  isFuture,
  isThisWeek,
  distanceInWordsToNow,
  differenceInWeeks,
  differenceInCalendarDays,
  addDays,
} from 'date-fns'

const TIME_FMT = 'hh:mm ss[s] A'

export const formatTimestamp = (datetime: string) => {
  if (!datetime) return null
  let ldatetime=new Date(datetime)
  if (isToday(ldatetime)) {
    return format(ldatetime, `[Today] ${TIME_FMT}`)
  } else if (isYesterday(ldatetime)) {
    return format(ldatetime, `[Yesterday] ${TIME_FMT}`)
  } else {
    return format(ldatetime, `ddd MM/DD/YY ${TIME_FMT}`)
  }
}

export const formatChartHourlyTimestamp = (datetime: string) => {
  if (!datetime) return null
  let ldatetime=new Date(datetime)
  if (isToday(ldatetime)) {
    return format(ldatetime, `[Today] ha`)
  } else if (isYesterday(ldatetime)) {
    return format(ldatetime, `[Yesterday] ha`)
  } else {
    return format(ldatetime, `M/D ha`)
  }
}

export const formatChartDailyTimestamp = (datetime: string) => {
  if (!datetime) return null
  let ldatetime=(new Date(datetime))

  if (isToday(ldatetime)) {
    return 'Today'
  } else if (isYesterday(ldatetime)) {
    return 'Yesterday'
  } else if (differenceInWeeks(addDays(new Date(), 1), ldatetime) < 1) {
    // Print timestamp as day name if less than 1 week ago.
    // If today is Friday, then previous Saturday will print as day but previous Friday will print as date
    return format(ldatetime, `ddd`)
  } else {
    return format(ldatetime, `M/D`)
  }
}

export const formatChartWeeklyTimestamp = (datetime: string) => {
  if (!datetime) return null

  let ldatetime=(new Date(datetime))
  if (isThisWeek(ldatetime)) {
    return 'This week'
  } else if (differenceInWeeks(new Date(), ldatetime) < 2) {
    return 'Last week'
  } else {
    return format(ldatetime, `[Week of] M/D`)
  }
}

export const formatLastSeen = (datetime: string) => {
  if (!datetime) return ''

  let ldatetime=(new Date(datetime))
  if (isFuture(ldatetime)) {
    return 'less than a minute ago'
  }
  return distanceInWordsToNow(ldatetime, {addSuffix: true})
}

export const formatCountdown = (datetime: string) => {
  if (!datetime) return ''
  let ldatetime=(new Date(datetime))
  return distanceInWordsToNow(ldatetime, {addSuffix: true})
}

export const dateDifferenceInWords = (datetime: string) => {
  if (!datetime) return null

  let ldatetime=(new Date(datetime))
  if (isToday(ldatetime)) {
    return 'Today'
  } else if (isYesterday(ldatetime)) {
    return 'Yesterday'
  } else if (isTomorrow(ldatetime)) {
    return 'Tomorrow'
  } else {
    return differenceInCalendarDays(ldatetime, new Date()) + ' days from now'
  }
}



// WEBPACK FOOTER //
// ./src/utils/date.js